import {
  ReturnsExclusionsMessage,
  returnsExclusionsMessages,
} from "../messaging";

export const getReturnsExclusionsMessage = (
  browsePageHierarchy: Array<{ categoryId: string }>,
  sellingProductType: string,
): ReturnsExclusionsMessage | undefined => {
  if (!browsePageHierarchy || !sellingProductType) return;

  return returnsExclusionsMessages.find((returnsExclusionsMessage) => {
    const matchedMessages = returnsExclusionsMessage.matches.filter(
      (returnsExclusionsMessageMatch) =>
        browsePageHierarchy.find(
          (hierarchyItem) =>
            hierarchyItem.categoryId ===
              returnsExclusionsMessageMatch.category &&
            returnsExclusionsMessageMatch.sellingProductTypes.includes(
              sellingProductType,
            ),
        ),
    );
    return matchedMessages.length > 0;
  });
};
